(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-mala"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__cbMalaInit) return;
    root.__cbMalaInit = true;
    var sticky = root.querySelector('[data-cb-mala-sticky-link]');
    var stickyText = root.querySelector('[data-cb-mala-sticky-text]');
    var stickyShell = root.querySelector('[data-cb-mala-sticky-shell]');
    function setSticky(){
      if(!sticky || !stickyText) return;
      sticky.href = sticky.getAttribute('data-post-url') || sticky.href;
      stickyText.textContent = sticky.getAttribute('data-post-label') || stickyText.textContent;
    }
    setSticky();
    if(stickyShell){
      var stickyTrigger = root.querySelector('[data-cb-mala-sticky-trigger]');
      var stickyOffset = parseInt(stickyShell.getAttribute('data-cb-mala-sticky-offset'), 10);
      if(isNaN(stickyOffset) || stickyOffset < 0) stickyOffset = 0;
      var ticking = false;
      var getStickyThreshold = function(){
        if(!stickyTrigger) return stickyOffset;
        var triggerRect = stickyTrigger.getBoundingClientRect();
        return window.scrollY + triggerRect.bottom;
      };
      var updateStickyVisibility = function(){
        ticking = false;
        stickyShell.classList.toggle('is-visible', window.scrollY >= getStickyThreshold());
      };
      var requestStickyUpdate = function(){
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStickyVisibility);
      };
      window.addEventListener('scroll', requestStickyUpdate, { passive:true });
      window.addEventListener('resize', requestStickyUpdate);
      updateStickyVisibility();
    }
    function suppressCardPopup(){
      document.querySelectorAll('#cbtpOverlay,.cbtp__overlay').forEach(function(el){
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.style.setProperty('opacity','0','important');
        el.style.setProperty('pointer-events','none','important');
        el.classList.remove('cbtp--open');
      });
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }
    suppressCardPopup();
    if(window.MutationObserver && document.body){
      var popupObserver = new MutationObserver(suppressCardPopup);
      popupObserver.observe(document.body, { childList:true, subtree:true });
    }
    window.addEventListener('scroll', suppressCardPopup, { passive:true });
    [500, 1500, 3000].forEach(function(delay){ window.setTimeout(suppressCardPopup, delay); });
    root.querySelectorAll('[data-cb-mala-quiz-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var quiz = btn.closest('[data-cb-mala-quiz]');
        if(!quiz) return;
        var v = quiz.querySelector('[data-cb-mala-quiz-verdict]');
        if(!v) return;
        var open = v.hasAttribute('hidden');
        if(open){ v.removeAttribute('hidden'); } else { v.setAttribute('hidden',''); }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.querySelectorAll('[data-cb-mala]').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-cb-mala]');
    init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbc-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CHIP = '[data-cbc-chip]';
    var cells = null;
    var chipsRoots = null;

    function getCells() { return document.querySelectorAll('[data-cbc-grid] [data-cbc-symbols]'); }

    function apply(tag, opts) {
      opts = opts || {};
      cells = getCells();
      if (!cells.length) return;
      var shown = 0;
      cells.forEach(function (c) {
        var syms = (c.getAttribute('data-cbc-symbols') || '').split(' ');
        var ok = (tag === 'all' || !tag) ? true : syms.indexOf(tag) !== -1;
        c.hidden = !ok;
        if (ok) shown += 1;
      });
      var count = document.querySelector('[data-cbc-count]');
      var reset = document.querySelector('[data-cbc-reset]');
      var empty = document.querySelector('[data-cbc-empty]');
      var label = '';
      document.querySelectorAll(CHIP).forEach(function (b) {
        var on = b.getAttribute('data-cbc-chip') === (tag || 'all');
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && tag && tag !== 'all') { var t = b.querySelector('.cbc-chip__txt'); label = t ? t.textContent.trim() : ''; }
      });
      if (count) count.textContent = shown + (shown > 1 ? ' bijoux' : ' bijou') + (label ? ' · ' + label : '');
      if (reset) reset.hidden = !(tag && tag !== 'all');
      if (empty) empty.hidden = shown !== 0;
      if (opts.hash !== false) {
        try {
          var h = (tag && tag !== 'all') ? '#' + tag : location.pathname + location.search;
          if (tag && tag !== 'all') history.replaceState(null, '', h); else history.replaceState(null, '', location.pathname + location.search);
        } catch (e) {}
      }
      if (opts.scroll) {
        var g = document.getElementById('cbc-grid');
        if (g) { var y = g.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); }
      }
    }

    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest(CHIP);
      if (chip) { apply(chip.getAttribute('data-cbc-chip'), { scroll: false }); return; }
      var jump = e.target.closest && e.target.closest('[data-cbc-jump]');
      if (jump) { e.preventDefault(); apply(jump.getAttribute('data-cbc-jump'), { scroll: true }); return; }
      var rs = e.target.closest && e.target.closest('[data-cbc-reset]');
      if (rs) { apply('all', { scroll: false }); }
    });

    function init() {
      if (!document.querySelector('[data-cbc-grid]')) return;
      var h = (location.hash || '').replace('#', '');
      var valid = h && document.querySelector('[data-cbc-chip="' + h + '"]');
      apply(valid ? h : 'all', { hash: false, scroll: !!valid });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbh-picker"]) return;
  try {
    
  (function () {
    var host = document.getElementById('cbh-pick');
    if (!host || host.dataset.cbhReady) return;
    host.dataset.cbhReady = '1';
    var status = host.querySelector('[data-cbh-status]');
    var at = Number(host.dataset.at || 6000);
    var cm = Number(host.dataset.cmProduct || 0);
    var bogo = String(host.dataset.bogoIds || '').split(',').filter(Boolean).map(Number);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function url(p) { return root.replace(/\/$/, '') + p; }
    function preview() { try { return localStorage.getItem('ky-hw-preview') === '1' || /[?&]hw_preview=1/.test(location.search); } catch (e) { return false; } }
    function active() {
      var now = Date.now();
      var s = Date.parse(host.dataset.start), e = Date.parse(host.dataset.end);
      if (now > e && !preview()) return 'ended';
      return 'ok';
    }
    function money(c) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100); }
    function isHw(i) { return i.properties && i.properties._hw_gift && String(i.properties._hw_gift) !== 'false'; }
    function isCm(i) { return Number(i.product_id) === cm || (i.properties && String(i.properties._gift) === 'true'); }
    function qualifying(cart) {
      var bq = cart.items.reduce(function (n, i) { return n + (bogo.indexOf(Number(i.product_id)) !== -1 ? i.quantity : 0); }, 0);
      return cart.items.reduce(function (t, i) {
        if (isHw(i) || isCm(i)) return t;
        if (bq >= 2 && bogo.indexOf(Number(i.product_id)) !== -1) return t;
        return t + Number(i.final_line_price || 0);
      }, 0);
    }
    function say(msg) { status.textContent = msg; status.hidden = !msg; }
    function json(p, body) {
      return fetch(url(p), { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }
    function mark(id) {
      host.querySelectorAll('[data-cbh-card]').forEach(function (c) { c.classList.toggle('is-picked', String(c.dataset.cbhCard) === String(id)); });
    }
    try { var saved = localStorage.getItem('ky-hw-choice'); if (saved) mark(saved); } catch (e) {}
    if (active() === 'ended') {
      host.classList.add('is-ended');
      host.querySelectorAll('[data-cbh-choose]').forEach(function (b) { b.disabled = true; });
      say(host.dataset.msgEnded);
      return;
    }
    host.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-cbh-choose]');
      if (!btn) return;
      var id = Number(btn.dataset.cbhChoose);
      btn.disabled = true;
      try { localStorage.setItem('ky-hw-choice', String(id)); } catch (e) {}
      mark(id);
      json('/cart.js').then(function (cart) {
        var q = qualifying(cart);
        if (q < at) {
          say(String(host.dataset.msgShort || '').replace('{x}', money(at - q)));
          return null;
        }
        var cur = cart.items.find(isHw);
        var drop = cur ? json('/cart/change.js', { id: cur.key, quantity: 0 }) : Promise.resolve();
        return drop.then(function () {
          return json('/cart/add.js', { items: [{ id: id, quantity: 1, properties: { _hw_gift: '1' } }] });
        }).then(function () {
          say(host.dataset.msgAdded);
          document.dispatchEvent(new CustomEvent('ky:cart:open'));
        });
      }).catch(function () {
        say(host.dataset.msgError);
      }).then(function () { btn.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbx-ete-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewMeta = {"bracelet-energie-en-aigue-marine":{"n":58,"avg":"4.74"},"bracelet-mala-guan-yin-pierre-de-lune-apatite-bleue":{"n":97,"avg":"4.80"},"mini-bracelet-energie-en-aigue-marine":{"n":51,"avg":"4.75"},"bracelet-energie-apatite":{"n":42,"avg":"4.69"},"bracelet-energie-amazonite":{"n":53,"avg":"4.83"},"bracelet-mala-ocean-en-amazonite-rhodochrosite-copy":{"n":53,"avg":"4.75"},"bracelet-mala-lotus-de-108-perles-en-amazonite-naturelle":{"n":444,"avg":"4.69"},"bracelet-genie-fluorite":{"n":69,"avg":"4.83"},"bracelet-energie-cristal":{"n":56,"avg":"4.79"},"bracelet-mala-lotus-de-108-perles-en-howlite":{"n":52,"avg":"4.77"},"mini-bracelet-en-cristal-de-roche-energie-copy":{"n":55,"avg":"4.75"},"bracelet-lotus-joie-de-letre-en-jaspe-dalmatien":{"n":142,"avg":"4.80"},"bracelet-energie-quartzrose":{"n":61,"avg":"4.79"},"bracelet-mala-reconfort-amour-de-bouddha-108-perles-en-quartz-rose":{"n":91,"avg":"4.74"},"mini-bracelet-energie-en-quartz-rose":{"n":75,"avg":"4.79"},"mini-bracelet-energie-rhodonite":{"n":58,"avg":"4.76"},"bracelet-energie-rhodonite-1":{"n":94,"avg":"4.74"},"mini-bracelet-en-cornaline-energie-copy":{"n":67,"avg":"4.75"},"bracelet-energie-labradorite":{"n":79,"avg":"4.80"},"bracelet-mala-miroir-emotionnel-en-labradorite":{"n":51,"avg":"4.75"},"mini-bracelet-energie-labradorite":{"n":66,"avg":"4.73"},"collier-labradorite-lumineuse-argent-925":{"n":72,"avg":"4.78"},"bracelet-energie-aventurine":{"n":59,"avg":"4.75"},"mini-bracelet-aventurine":{"n":76,"avg":"4.79"},"bracelet-fluidite-energie":{"n":95,"avg":"4.80"},"bracelet-revelation-apatite":{"n":88,"avg":"4.77"},"mini-bracelet-amethyste":{"n":119,"avg":"4.78"},"bracelet-mala-bouddhiste-en-amethyste":{"n":326,"avg":"4.69"},"collier-porte-pierre-precieuse":{"n":62,"avg":"4.76"},"set4-minibracelets-mespreferes":{"n":86,"avg":"4.76"},"bracelets-liberation-emotionnelle":{"n":64,"avg":"4.73"},"set3-minibracelets-amour":{"n":41,"avg":"4.63"}};
    const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
    const stone = (title) => {
      const match = title.match(/(?:en |& )([A-ZÀ-Ö][A-Za-zÀ-ÿ\- ]+?)(?: "| et | &|$)/);
      return match ? match[1].trim() : 'Pierre naturelle';
    };

    document.querySelectorAll('[data-cbx-ete-root]').forEach((root) => {
      if (root.dataset.cbxEteReady === 'true') return;
      root.dataset.cbxEteReady = 'true';
      const dataIsland = root.querySelector('[data-cbx-ete-products]');
      let products = [];
      try { products = JSON.parse(dataIsland.textContent); } catch (error) { products = []; }
      const selection = [];
      const grid = root.querySelector('[data-cbx-ete-grid]');
      const tray = root.querySelector('[data-cbx-ete-tray]');
      const slots = root.querySelector('[data-cbx-ete-slots]');
      const counter = root.querySelector('[data-cbx-ete-counter]');
      const status = root.querySelector('[data-cbx-ete-status]');
      const priceBox = root.querySelector('[data-cbx-ete-price]');
      const cta = root.querySelector('[data-cbx-ete-cta]');
      const errorBox = root.querySelector('[data-cbx-ete-error]');

      products.forEach((product, index) => {
        const card = document.createElement('article');
        const reviews = reviewMeta[product.handle];
        const url = escapeHtml(product.url);
        const title = escapeHtml(product.title);
        card.className = 'cbx-ete__product-card';
        card.dataset.index = index;
        if (!product.available) card.classList.add('is-unavailable');
        card.innerHTML = `<a class="cbx-ete__product-media" href="${url}"><img class="cbx-ete__product-image" loading="lazy" width="600" height="600" src="${escapeHtml(product.img)}" alt="${title}">${product.available ? '' : '<span class="cbx-ete__unavailable">Épuisé</span>'}</a>${product.available ? `<button class="cbx-ete__select-pill" type="button" aria-pressed="false" aria-label="Ajouter ${title} à mon trio, ${money.format(product.price / 100)}" data-cbx-ete-pill>+</button>` : ''}<span class="cbx-ete__product-body"><a class="cbx-ete__product-title" href="${url}">${title}</a><span class="cbx-ete__meta-row"><span class="cbx-ete__stone">${escapeHtml(stone(product.title))}</span><span class="cbx-ete__price">${money.format(product.price / 100)}</span></span>${reviews ? `<span class="cbx-ete__rating"><span class="cbx-ete__stars">★★★★★</span><span class="cbx-ete__rating-value">${reviews.avg.replace('.', ',')}</span><span class="cbx-ete__rating-count">(${reviews.n})</span></span>` : ''}</span>`;
        const pill = card.querySelector('[data-cbx-ete-pill]');
        if (pill) pill.addEventListener('click', () => toggle(index));
        grid.append(card);
      });

      function toggle(index) {
        const position = selection.indexOf(index);
        if (position > -1) selection.splice(position, 1);
        else {
          if (selection.length === 3) {
            const dropped = selection.shift();
            const oldCard = grid.children[dropped];
            oldCard.classList.add('cbx-ete__product-card--dropped');
            window.setTimeout(() => oldCard.classList.remove('cbx-ete__product-card--dropped'), 700);
          }
          selection.push(index);
        }
        render();
      }

      function render() {
        [...grid.children].forEach((card, index) => {
          const selected = selection.includes(index);
          card.classList.toggle('is-selected', selected);
          const pill = card.querySelector('.cbx-ete__select-pill');
          if (pill) {
            pill.textContent = selected ? '✓' : '+';
            pill.setAttribute('aria-pressed', String(selected));
          }
        });
        counter.textContent = `${selection.length} sur 3 sélectionnée${selection.length > 1 ? 's' : ''}`;
        tray.classList.toggle('cbx-ete__tray--visible', selection.length > 0);
        slots.innerHTML = [0, 1, 2].map((unused, index) => selection[index] !== undefined
          ? `<div class="cbx-ete__tray-slot cbx-ete__tray-slot--filled"><img class="cbx-ete__tray-image" width="54" height="54" src="${escapeHtml(products[selection[index]].img)}" alt="${escapeHtml(products[selection[index]].title)}"></div>`
          : `<div class="cbx-ete__tray-slot">${index + 1}</div>`).join('');
        const left = 3 - selection.length;
        status.textContent = left === 0
          ? 'Votre trio est complet'
          : `Encore ${left} pièce${left > 1 ? 's' : ''} · la 3ᵉ offerte`;
        cta.classList.toggle('cbx-ete__tray-cta--active', selection.length > 0);
        cta.textContent = left === 0
          ? 'Ajouter mon trio, la 3ᵉ offerte'
          : selection.length === 0
            ? 'Ajouter mon trio au panier'
            : `Ajouter ma sélection (${selection.length})`;
        if (!left) {
          const chosen = selection.map((index) => products[index]);
          const subtotal = chosen.reduce((sum, product) => sum + product.price, 0);
          const free = chosen.reduce((lowest, product) => product.price < lowest.price ? product : lowest, chosen[0]);
          const total = subtotal - free.price;
          priceBox.hidden = false;
          priceBox.innerHTML = `<span class="cbx-ete__tray-subtotal">Sous-total ${money.format(subtotal / 100)} · <s class="cbx-ete__struck-price">${money.format(free.price / 100)}</s> <span class="cbx-ete__offert">OFFERTE</span></span><strong class="cbx-ete__tray-total">Total ${money.format(total / 100)}</strong><span class="cbx-ete__saving">Vous économisez ${money.format(free.price / 100)}</span>`;
        } else {
          priceBox.hidden = true;
          priceBox.innerHTML = '';
        }
      }

      function openCart() {
        if (window.KYCart && typeof window.KYCart.refresh === 'function' && typeof window.KYCart.open === 'function') {
          window.KYCart.open();
          window.KYCart.refresh().catch(() => {});
        } else {
          window.location.assign('/cart');
        }
      }

      cta.addEventListener('click', async () => {
        errorBox.hidden = true;
        errorBox.textContent = '';
        if (selection.length === 0) return;
        cta.disabled = true;
        cta.textContent = 'Ajout en cours…';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: selection.map((index) => ({ id: products[index].id, quantity: 1 })) })
          });
          if (!response.ok) throw new Error(`cart/add.js ${response.status}`);
          selection.length = 0;
          openCart();
        } catch (error) {
          errorBox.textContent = "Une erreur est survenue. Votre sélection n'a pas été ajoutée. Veuillez réessayer.";
          errorBox.hidden = false;
          errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } finally {
          cta.disabled = false;
          render();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ky-journal-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const PAGE_SIZE = 12;

    const bindJournal = (root) => {
      if (root.dataset.journalBound === 'true') return;
      root.dataset.journalBound = 'true';

      const cards = Array.from(root.querySelectorAll('.jcard'));
      const filterButtons = Array.from(root.querySelectorAll('[data-filter]'));
      const searchInput = root.querySelector('[data-journal-search]');
      const headNote = root.querySelector('[data-journal-headnote]');
      const headline = root.querySelector('[data-journal-headline]');
      const loadMore = root.querySelector('[data-journal-more]');
      const emptyState = root.querySelector('[data-journal-empty]');
      let activeFilter = 'all';
      let searchTerm = '';
      let visibleLimit = PAGE_SIZE;

      const normalize = (value) => (value || '').toLocaleLowerCase('fr').trim();

      const getMatches = () => cards.filter((card) => {
        const matchesFilter = activeFilter === 'all' || card.dataset.blog === activeFilter;
        const searchableText = normalize(`${card.dataset.title || ''} ${card.dataset.tags || ''}`);
        const matchesSearch = searchTerm === '' || searchableText.includes(searchTerm);
        return matchesFilter && matchesSearch;
      });

      const render = () => {
        const matches = getMatches();

        cards.forEach((card) => card.classList.add('is-hidden'));
        matches.slice(0, visibleLimit).forEach((card) => card.classList.remove('is-hidden'));

        if (emptyState) {
          emptyState.hidden = matches.length > 0;
        }

        if (headNote) {
          headNote.textContent = `${matches.length} article${matches.length === 1 ? '' : 's'}`;
        }

        if (loadMore) {
          loadMore.classList.toggle('is-hidden', matches.length <= visibleLimit);
        }
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.filter || 'all';
          visibleLimit = PAGE_SIZE;

          if (headline && button.dataset.head) {
            headline.innerHTML = button.dataset.head;
          }

          filterButtons.forEach((candidate) => {
            const isActive = candidate === button;
            candidate.classList.toggle('on', isActive);
            candidate.setAttribute('aria-pressed', String(isActive));
          });

          render();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', () => {
          searchTerm = normalize(searchInput.value);
          visibleLimit = PAGE_SIZE;
          render();
        });
      }

      if (loadMore) {
        loadMore.addEventListener('click', () => {
          visibleLimit += PAGE_SIZE;
          render();
        });
      }

      render();
    };

    document.querySelectorAll('.ky-journal-index').forEach(bindJournal);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.ky-journal-index').forEach(bindJournal);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ky-pierre-fiche"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.kyPfReady === 'true') return;
      root.dataset.kyPfReady = 'true';
      root.addEventListener('click', function (event) {
        var question = event.target.closest('.fp-faq__question');
        if (!question || !root.contains(question)) return;
        var item = question.closest('.fp-faq__item');
        if (!item) return;
        var isOpen = item.classList.toggle('fp-faq__item--open');
        question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    function initAll() { Array.prototype.slice.call(document.querySelectorAll('[data-ky-pf-root]')).forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ky-pierres-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return (value || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }
    function hasToken(haystack, needle) {
      if (!needle) return true;
      return (' ' + (haystack || '').trim() + ' ').indexOf(' ' + needle + ' ') !== -1;
    }
    function init(root) {
      if (root.dataset.kyPhReady === 'true') return;
      root.dataset.kyPhReady = 'true';
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ky-ph-card]'));
      var count = root.querySelector('[data-ky-ph-count]');
      var grid = root.querySelector('[data-ky-ph-grid]');
      var empty = root.querySelector('[data-ky-ph-empty]');
      var search = root.querySelector('[data-ky-ph-search]');
      var resets = Array.prototype.slice.call(root.querySelectorAll('[data-ky-ph-reset]'));
      var state = { intention: '', element: '', chakra: '', query: '' };
      function setActive(type, value) {
        Array.prototype.slice.call(root.querySelectorAll('[data-filter-type="' + type + '"]')).forEach(function (button) {
          var isActive = (button.getAttribute('data-filter-value') || '') === value;
          button.classList.toggle('gp-chip--active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }
      function render() {
        var visible = 0;
        cards.forEach(function (card) {
          var name = normalize(card.getAttribute('data-name'));
          var show = hasToken(card.getAttribute('data-intentions'), state.intention) &&
            (!state.element || card.getAttribute('data-element') === state.element) &&
            hasToken(card.getAttribute('data-chakras'), state.chakra) &&
            (!state.query || name.indexOf(normalize(state.query)) !== -1);
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (grid) grid.hidden = visible === 0;
        if (empty) empty.hidden = visible !== 0;
        if (count) count.textContent = visible + ' pierre' + (visible > 1 ? 's' : '');
        var active = !!(state.intention || state.element || state.chakra || state.query);
        resets.forEach(function (button) { button.classList.toggle('gp-reset--visible', active); });
      }
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-filter-type]');
        if (!button || !root.contains(button)) return;
        var type = button.getAttribute('data-filter-type');
        var value = button.getAttribute('data-filter-value') || '';
        state[type] = value;
        setActive(type, value);
        render();
      });
      resets.forEach(function (button) {
        button.addEventListener('click', function () {
          state = { intention: '', element: '', chakra: '', query: '' };
          if (search) search.value = '';
          setActive('intention', ''); setActive('element', ''); setActive('chakra', ''); render();
        });
      });
      if (search) search.addEventListener('input', function () { state.query = search.value; render(); });
      render();
    }
    function initAll() { Array.prototype.slice.call(document.querySelectorAll('[data-ky-ph-root]')).forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
